import { ApiPath } from '@/common/app/api-path';
import { type GroupFriends } from '@/common/types/groupFriendsType';

import { api } from '../base';

export const groupApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getUserFriendsGroup: builder.query<GroupFriends, { page: number }>({
      query: (params) => ({
        url: ApiPath.GET_USER_GROUP,
        params,
      }),
      keepUnusedDataFor: 0,
    }),
    createUserFriendsGroup: builder.mutation<
      GroupFriends,
      { groupName: string }
    >({
      query: (body) => ({
        url: ApiPath.CREATE_USER_GROUP,
        method: 'POST',
        body,
      }),
    }),
    acceptInviteToFriendsGroup: builder.mutation<
      GroupFriends,
      { uniqueGroupKey: string }
    >({
      query: ({ uniqueGroupKey }) => ({
        url: ApiPath.ACCEPT_INVITE_TO_FRIENDS_GROUP + '/' + uniqueGroupKey,
        method: 'POST',
      }),
    }),
    removeParticipantFromFriendsGroup: builder.mutation<
      GroupFriends,
      { participantId: string }
    >({
      query: ({ participantId }) => ({
        url: ApiPath.REMOVE_PARTICIPANT_FROM_USER_GROUP + participantId,
        method: 'PATCH',
      }),
    }),
    changeFriendsGroupName: builder.mutation<
      GroupFriends,
      { groupName: string }
    >({
      query: (body) => ({
        url: ApiPath.CHANGE_USERS_GROUP_NAME,
        method: 'PATCH',
        body,
      }),
    }),
    leaveFromFriendsGroup: builder.mutation<void, void>({
      query: () => ({
        url: ApiPath.LEAVE_FROM_USER_GROUP,
        method: 'PATCH',
      }),
    }),
  }),
});
export const {
  useGetUserFriendsGroupQuery,
  useLazyGetUserFriendsGroupQuery,
  useCreateUserFriendsGroupMutation,
  useAcceptInviteToFriendsGroupMutation,
  useRemoveParticipantFromFriendsGroupMutation,
  useChangeFriendsGroupNameMutation,
  useLeaveFromFriendsGroupMutation,
} = groupApi;
